import { apiClient } from './apiClient';
// import axios from 'axios';

import config from '../config/environment';
const BASE_URL = config.BASE_URL;

const apiClientProductService = async (endpoint: string, method: string) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, { method, headers });
    return await response.json();
  } catch (error) {
    return {
      success: false,
      message: 'API request failed',
      data: [],
    };
  }
};

const List = () => apiClientProductService('/retailer_app.mob.v15.v1.products_list.merge_responce', 'GET');
const Details = (itemCode: string) =>
  apiClientProductService(`/retailer_app.mob.v15.v1.product_details.details?item_code=${itemCode}`, 'GET');
const AddToCart = (data: any) => apiClient('/retailer_app.mob.v15.v1.website_cart.update_cart', 'POST', data);
const ItemQytPlusMinus = (data: any) => apiClient('/retailer_app.mob.v15.v1.cart.update_cart_item_qty', 'POST', data);
const ApplyCoupon = (customerId: number, couponCode: string) =>
  apiClient(
    `/retailer_app.mob.v15.v1.website_cart.get_cart?customer_id=${customerId}&coupon_code=${couponCode}`,
    'GET'
  );
const RemoveCoupen = (customerId: number, removeCoupen: number) =>
  apiClient(
    `/retailer_app.mob.v15.v1.website_cart.get_cart?customer_id=${customerId}&remove_coupon=${removeCoupen}`,
    'GET'
  );
const GetCustomerProductCartList = (coustomerId: string) =>
  apiClient(`/retailer_app.mob.v15.v1.website_cart.get_cart?customer_id=${coustomerId}`, 'GET');
const PlaceOrderProducts = (data: any) =>
  apiClient('/retailer_app.mob.v15.v1.website_cart.place_cart_order', 'POST', data);

const RatingReview = (data: any) => apiClient('/retailer_app.api.retailer.add_item_review', 'POST', data);
// Utility function to get token headers
// const getAuthHeaders = () => {
//   const userLoginData = localStorage.getItem('userLoginData');
//   if (userLoginData) {
//     const parsedUserData = JSON.parse(userLoginData);
//     if (parsedUserData?.api_key && parsedUserData?.api_secret) {
//       return {
//         Authorization: `token ${parsedUserData.api_key}:${parsedUserData.api_secret}`,
//       };
//     }
//   }
//   return {};
// };

// // Axios API function
// const ItemQytPlusMinusNew = async (adata: any) => {
//   try {
//     const headers = {
//       'Content-Type': 'application/json',
//       ...getAuthHeaders(),
//     };
//     const response = await axios.post(
//       'http://192.168.1.25:8009/api/method/retailer_app.mob.v15.v1.cart.update_cart_item_qty',
//       adata,
//       {
//         headers: headers,
//         withCredentials: true,
//       }
//     );
//     return response.data;
//   } catch (error: any) {
//     if (error.response) {
//       return {
//         success: false,
//         message: error.response.data.message || 'API Error occurred.',
//       };
//     } else {
//       // console.log('Request failed:', error.message);
//       return {
//         success: false,
//         message: 'Something went wrong while updating item quantity.',
//       };
//     }
//   }
// };

export const ProductsService = {
  List,
  Details,
  AddToCart,
  ItemQytPlusMinus,
  // ItemQytPlusMinusNew,
  GetCustomerProductCartList,
  ApplyCoupon,
  RemoveCoupen,
  PlaceOrderProducts,
  RatingReview,
};
